import { useAppDataContext } from '@cox/core-ui8/dist/AppDataContext'
import ErrorContent from '../components/error'

const Error = () => {
  const { appData } = useAppDataContext()
  const sections = (appData as any)?.page?.template?.sections || (appData as any)?.page?.sections || {}
  const errorCode: number = sections?.errorCode || 500

  return (
    <>
      <ErrorContent errorCode={errorCode} />
    </>
  )
}

export default Error
